module.exports = __webpack_public_path__ + "img/DOC-small.9ee63fd.svg";